import React from 'react'
import { Box } from '@mui/material'

interface EditableTypographyProps {
  htmlContent: string
}

export function EditableTypography({
  htmlContent,
}: EditableTypographyProps) {
  const normalized = (htmlContent ?? '')
    .replace(/&nbsp;/g, ' ')
    .replace(/\u00a0/g, ' ')

  return (
    <Box
      sx={{
        p: 1,
        minWidth: 0,
        fontFamily: 'Montserrat',
        fontSize: '12px',
        lineHeight: '20px',
        fontWeight: 400,
        color: 'rgba(56, 57, 59, 1)',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
        '& p': { margin: 0 },
        '& .ql-size-small': { fontSize: '0.75em' },
        '& .ql-size-large': { fontSize: '1.5em' },
        '& .ql-size-huge': { fontSize: '2.5em' },
      }}
      dangerouslySetInnerHTML={{ __html: normalized }}
    />
  )
}
